module.exports = __webpack_public_path__ + "img/4-8-2.fa61e09a.png";